import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconOutgoingCallProps } from './IconOutgoingCall.types'
import * as Styled from './styles/IconOutgoingCall.style'

import { nonThemeableRules } from '../../ruleSet'

const IconOutgoingCall: FC<IconOutgoingCallProps> = ({
  size = nonThemeableRules.defaultSize as number as IconOutgoingCallProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconOutgoingCallProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M19.527 9.566V4.531h-5.039m5.028.012-6.493 6.488m8.469 6.184a.3.3 0 0 1 .016.105 3.412 3.412 0 0 1-.153.97c-.375 1.214-1.386 2.523-2.582 2.874-3.015.898-6.191-.023-9-1.434a12.129 12.129 0 0 1-5.386-5.347c-1.414-2.797-2.34-5.957-1.438-8.957.356-1.188 1.676-2.196 2.895-2.567l.98-.257a.318.318 0 0 1 .383.203L7.98 5.07l1.184 3.305.027.086a.374.374 0 0 1-.125.426 4.328 4.328 0 0 1-1.27.664 7.861 7.861 0 0 1-1.671.324.37.37 0 0 0-.27.164.372.372 0 0 0-.043.309 12.339 12.339 0 0 0 3.012 4.976 12.32 12.32 0 0 0 5 3.004c.106.035.219.02.309-.043a.366.366 0 0 0 .164-.265 7.632 7.632 0 0 1 .328-1.672 4.26 4.26 0 0 1 .672-1.262.367.367 0 0 1 .426-.125l.086.027 3.316 1.18c.79.277 1.46.559 2.25.84.047.015.094.133.117.207Zm0 0'
          fill='none'
          vectorEffect='non-scaling-stroke'
        />
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconOutgoingCall
